import { ReactNode } from 'react';

import SVG from '../../../components/SVG/SVG';
import Stack from '../../../components/Stack/Stack';
import Well from '../../../components/Well/Well';

import styles from './IllustratedMessage.module.css';

type IllustratedMessageProps = {
    icon: string;
    children?: ReactNode;
};

const IllustratedMessage = ({ icon, children }: IllustratedMessageProps) => (
    <Well>
        <Stack>
            <SVG src={icon} className={styles.Illustration} />
            {children}
        </Stack>
    </Well>
);

export default IllustratedMessage;
